/**
 * Version EN VIGUEUR des conditions générales de vente et d'utilisation.
 *
 * Changer de version = nouveau PDF dans `public/legal/`, nouveau texte dans
 * `src/app/(marketing)/legal/cgv/`, puis ces trois valeurs. Chaque compte qui
 * n'a pas accepté la version courante se la voit présenter à sa prochaine
 * visite (`ConditionsGate`), et chaque souscription l'accepte à nouveau.
 */
export const CONDITIONS = {
  version: "1.6",
  date: "13 octobre 2026",
  url: "/legal/cgv",
  pdf: "/legal/synoplix-cgv-cgu-v1.6.pdf",
} as const;
